// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Completions_InferResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /completions/completions/infer
 *
 * The success payload is the LLM-populated JSON object, which mirrors the
 * caller-defined `jsonSchemaToFill` input (clientes form, orcamento form,
 * anything). Its shape is intentionally opaque to this endpoint, so `dados`
 * is emitted as the dynamic object verbatim via the getDados() override.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Completions_InferResponseDados = unknown;

export type Completions_InferResponse = ApiResponse<Completions_InferResponseDados>;

registerResponseContract('Completions_InferResponse', {})
